import { UPDATE_PROFILE } from "../actionTypes";

const initialState = {
  name: "",
  icon: "",
  address: "",
  email: "",
  pageList: [],
  pageMap: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_PROFILE: {
      const { content } = action.payload;

      // menu转化为page tree
      const pageList: Array<any> = content.menuList || [];
      // const map = pageList.reduce<{ [key: string]: Array<any> }>((re, v) => {
      //   const key = v.pid || "-1";
      //   re[key] || (re[key] = []);
      //   re[key].push(v);
      //   return re;
      // }, {});
      // const setItems = (items) => {
      //   items.sort((a, b) => b.sortNo - a.sortNo);
      //   items?.forEach((v) => {
      //     if (isNull(v.path)) {
      //       v.path = `/${v.name}`;
      //     }
      //     v.icon = "list";
      //     const list = map[v._id]?.map((vv) => ({
      //       ...vv,
      //       icon: "list",
      //       path: `${v.path}/${vv.name}`,
      //     }));
      //     v.items = list;
      //     if (list?.length > 0) setItems(list);
      //   });
      // };
      // setItems(map["-1"]);
      // const menuTree = map["-1"];
      const menuTree = pageList;
      // console.log("tree:", menuTree);

      return {
        ...state,
        ...content,
        pageList,
        menuTree,
      };
    }
    default:
      return state;
  }
}
